import {EventFilters} from "@lib/Event/EventModels";
import {useMemo} from "react";
import {cleanObject} from "@commons/misc/cleanObject";
import {useQuery} from "@tanstack/react-query";
import {qk} from "@queries/keys";
import {RedemptionFilters} from "@lib/Redemption/RedemptionModels";
import RedemptionService from "@lib/Redemption/RedemptionService";

export function useRedemptions(filters?: RedemptionFilters) {

    const cleanFilters = useMemo(
        () => cleanObject(filters, {removeEmptyString: true}),
        [filters]
    ) as Required<EventFilters>;

    return useQuery({
        queryKey: qk.redemptions(cleanFilters),
        queryFn: () => RedemptionService.getRedemptions(cleanFilters),
        staleTime: 10 * 60_000,
        retry: 1,
    });
}

export function useRedemption(rdmId?: string) {
    return useQuery({
        queryKey: qk.redemption(rdmId),
        queryFn: () => {
            if (!rdmId) throw new Error('Missing eventId');
            return RedemptionService.getRedemptionDetails(rdmId)
        },
        staleTime: 10 * 60_000,
        retry: 1,
        enabled: !!rdmId,
    });
}